import { render, staticRenderFns } from "./ExpertiseTabItems.vue?vue&type=template&id=25ac4e17&scoped=true"
import script from "./ExpertiseTabItems.vue?vue&type=script&lang=js"
export * from "./ExpertiseTabItems.vue?vue&type=script&lang=js"
import style0 from "./ExpertiseTabItems.vue?vue&type=style&index=0&id=25ac4e17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ac4e17",
  null
  
)

export default component.exports